import {SET_CONTACTS, ADD_CONTACT, DELETE_CONTACT, UPDATE_CONTACT} from "../constants/contacts";

const initialState = {
  contacts: []
};

const contactsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTACTS:
      return {
        ...state,
        contacts: action.data,
      };
    case ADD_CONTACT:
      return {
        ...state,
        contacts: state.contacts.concat(action.newContact),
      };
    case DELETE_CONTACT:
      return {
        ...state,
        contacts: state.contacts.filter( c => c.id !== action.contactId),
      };
      case UPDATE_CONTACT:
        return {
          ...state,
          contacts: state.contacts.map( c => c.id !== action.contactId ? c : action.updatedContact),
        };
    default:
      return state;
  }
};

export default contactsReducer;